<template>
  <div>
    <el-dialog :visible.sync="detail.dialog" title="投诉详情" width="50%">
      <complaint-detail v-if="detail.dialog" :id="detail.id"></complaint-detail>
    </el-dialog>

    <el-table :data="list" stripe>
      <el-table-column label="#" type="index" width="70"></el-table-column>
      <el-table-column label="被投诉用户" prop="userName" width="120"></el-table-column>
      <el-table-column label="投诉类型" prop="type" width="110"></el-table-column>
      <el-table-column label="投诉内容" prop="content"></el-table-column>
      <el-table-column label="投诉时间" prop="createdAt" width="160"></el-table-column>
      <el-table-column label="提交人" prop="createBy" width="170"></el-table-column>
      <el-table-column label="操作" width="70">
        <template v-slot:default="scope">
          <el-button size="mini" type="text" @click="handleShow(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {complaint} from "@/api/miu/complaint";
import ComplaintDetail from "@/components/ComplaintDetail.vue";

export default {
  name: 'ComplaintManage',
  components: {ComplaintDetail},
  data() {
    return {
      list: [],
      detail: {
        dialog: false,
        id: null
      }
    };
  },

  created() {
    console.log("ComplaintManage created")
    this.getData();
  },

  methods: {
    handleShow(id) {
      console.log("handleShow id = " + id);

      this.detail.id = id;
      this.detail.dialog = true;
    },

    getData() {
      complaint.list({
        pageCurrent: 1,
        pageSize: 10,
        keyword: null,
        type: null,
        createBy: null,
        miuUserId: null,
      }).then(res => {
        this.list = res.data.list;
      })
    },
  },


};
</script>

<style scoped>
</style>
